import { Link } from "react-router-dom";

const MenuButton = (props) => {
  const { to, icon, children } = props;
  return (
    <div id='menubutton'>
      <Link to={to} className='btn btn-primary btn-menu w-100 d-flex justify-content-center text-nowrap '>
        {icon} <span>{children}</span>
      </Link>
    </div>
  );
};

export default MenuButton;
